import React from 'react';
import { EmptyState } from 'core/components';
import ToolResultCard from 'app/views/core/kaizen/components/ToolResultCard';
import TracerouteText from 'app/views/synthetics/components/TracerouteText';

export default function SyntheticsTraceResultsToolResult({ tool = {}, onCloseToolResult, isInlineMode }) {
  const results = tool?.raw_result || [];

  return (
    <ToolResultCard
      tool={tool}
      onCloseToolResult={onCloseToolResult}
      isInlineMode={isInlineMode}
      title={tool?.title || 'Trace Results'}
      minHeight={750}
      px={2}
    >
      {results.length > 0 ? (
        <TracerouteText traceData={results} />
      ) : (
        <EmptyState m={2} icon="disable" title="No Trace Results Found" />
      )}
    </ToolResultCard>
  );
}
